// extracted by mini-css-extract-plugin
export var pointContainer = "service-point-container-module--pointContainer--3yQox";
export var picture = "service-point-container-module--picture--3Fcfp";
export var pointContainer__header = "service-point-container-module--pointContainer__header--34KkK";